import React from 'react'
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
function SvgCmp({src}) {
  return (
    <div>
      <SVG  src={toAbsoluteUrl({src})} />
    </div>
  )
}

export default SvgCmp